/**
 * FAQ answer HTML — strip stale Gutenberg block comments if API not re-exported yet.
 *
 * @param {string} [html]
 */
export function faqAnswerHtml(html) {
  if (!html) return '';
  return String(html).replace(/<!-- \/?wp:[^>]*-->/g, '').trim();
}

/**
 * FAQ items by WordPress post IDs (block selection order).
 *
 * @param {import('@/types/cms').FaqItem[] | undefined} items
 * @param {number[] | undefined} ids
 */
export function faqsByIds(items, ids) {
  if (!ids?.length) return [];

  const byId = new Map((items || []).filter((f) => f.id).map((f) => [f.id, f]));
  return ids.map((id) => byId.get(id)).filter(Boolean);
}

/**
 * FAQ items for a page slug (CPT association + legacy scope fallback).
 *
 * @param {import('@/types/cms').FaqItem[] | undefined} items
 * @param {string} [pageSlug='/']
 */
export function faqsForPage(items, pageSlug = '/') {
  const slug = pageSlug || '/';

  return (items || [])
    .filter((faq) => {
      if (faq.pages?.length) {
        return faq.pages.includes(slug);
      }
      if (!faq.scope?.length) {
        return slug === '/';
      }
      return false;
    })
    .sort((a, b) => a.sort_order - b.sort_order);
}
